import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=37ea573c&scoped=true&"
import script from "./BackToTop.vue?vue&type=script&lang=js&"
export * from "./BackToTop.vue?vue&type=script&lang=js&"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=37ea573c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea573c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ea573c')) {
      api.createRecord('37ea573c', component.options)
    } else {
      api.reload('37ea573c', component.options)
    }
    module.hot.accept("./BackToTop.vue?vue&type=template&id=37ea573c&scoped=true&", function () {
      api.rerender('37ea573c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/BackToTop.vue"
export default component.exports